import script from "./account-main-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./account-main-list.vue?vue&type=script&lang=tsx&setup=true"

import "./account-main-list.vue?vue&type=style&index=0&id=2d89b4b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d89b4b4"]])

export default __exports__